import { Star } from "lucide-react";
import { Reveal } from "./Reveal";
import { REVIEWS } from "./data";

const Stars = () => (
  <div className="flex gap-1">
    {[...Array(5)].map((_, i) => (
      <Star key={i} className="h-4 w-4 fill-blue-400 text-blue-400" />
    ))}
  </div>
);

export default function Reviews() {
  return (
    <section
      id="bewertungen"
      data-testid="reviews-section"
      className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32"
    >
      <Reveal className="flex flex-wrap items-end justify-between gap-6">
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-blue-400">
            (03) — Bewertungen
          </p>
          <h2 className="mt-4 font-display text-3xl font-extrabold text-slate-50 sm:text-5xl">
            Gütersloh <span className="text-outline">vertraut uns.</span>
          </h2>
        </div>
        <div
          data-testid="google-rating-badge"
          className="flex items-center gap-3 rounded-full border border-white/10 bg-[#0d0f17] px-5 py-3"
        >
          <Stars />
          <span className="font-display text-lg font-bold text-slate-50">4,9</span>
          <span className="text-xs text-slate-500">/ 5 bei Google</span>
        </div>
      </Reveal>

      <div className="mt-14 grid gap-6 md:grid-cols-3">
        {REVIEWS.map((r, i) => (
          <Reveal key={r.name} delay={i * 0.1} className="h-full">
            <figure
              data-testid={`review-card-${i + 1}`}
              className="flex h-full flex-col rounded-2xl border border-white/10 bg-[#0d0f17] p-8 transition-all duration-500 hover:-translate-y-1.5 hover:border-blue-400/30"
            >
              <Stars />
              <blockquote className="mt-5 flex-1 text-sm leading-relaxed text-slate-300">
                „{r.text}“
              </blockquote>
              <figcaption className="mt-6 border-t border-white/10 pt-4">
                <p className="font-semibold text-slate-50">{r.name}</p>
                <p className="mt-0.5 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">
                  {r.device}
                </p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
